import { Switch, SwitchProps } from '@chakra-ui/react';
import styled from '@emotion/styled';
import React from 'react';
import customTheme from '~/styles/theme';

const StyledSwitch = styled(Switch)`
  input:focus:not([data-focus-visible-added]) + .chakra-switch__track {
    box-shadow: none;
  }
  .chakra-switch__track {
    background-color: ${customTheme.colors.white};
    border: 1px solid;
    border-color: ${({ theme }: typeof customTheme) =>
      theme.colors.primary[500]};

    &:hover,
    &:focus-visible {
      outline: 3px solid;
      outline-color: ${({ theme }: typeof customTheme) =>
        theme.colors.primary[100]};
    }
    &:active {
      outline: 3px solid;
      outline-color: ${({ theme }: typeof customTheme) =>
        theme.colors.primary[200]};
    }
  }

  .chakra-switch__thumb {
    background-color: ${({ theme }: typeof customTheme) =>
      theme.colors.primary[500]};
  }

  input[type='checkbox']:checked + .chakra-switch__track,
  input[type='checkbox'][aria-checked='mixed'] + .chakra-switch__track {
    background-color: ${({ theme }: typeof customTheme) =>
      theme.colors.secondary[500]};
    border-color: ${({ theme }: typeof customTheme) =>
      theme.colors.secondary[500]};

    &:hover,
    &:focus-visible {
      background-color: ${({ theme }: typeof customTheme) =>
        theme.colors.secondary[600]};
      outline: 3px solid;
      outline-color: ${({ theme }: typeof customTheme) =>
        theme.colors.secondary[50]};
    }
    &:active {
      background-color: ${({ theme }: typeof customTheme) =>
        theme.colors.secondary[700]};
      outline: 3px solid;
      outline-color: ${({ theme }: typeof customTheme) =>
        theme.colors.secondary[100]};
    }
  }
  input[type='checkbox']:checked
    + .chakra-switch__track
    > .chakra-switch__thumb,
  input[type='checkbox'][aria-checked='mixed']
    + .chakra-switch__track
    > .chakra-switch__thumb {
    background-color: ${({ theme }: typeof customTheme) => theme.colors.white};
  }
`;

const Toggle: React.FC<SwitchProps> = ({ ...props }) => {
  return <StyledSwitch {...props} />;
};

export default Toggle;
